export interface Category {
  _id: string;
  accountId: string;
  type: string;
  status: string;
  phoneNumber: string;
  categories: CategoryElement[];
  createdAt: Date;
  createdBy: string;
  isDeleted: boolean;
}

export interface CategoryElement {
  _id: string;
  languages: Language[];
  icon: string;
  hexaColor?: string;
  textColor?: string;
  status: string;
}

export interface Language {
  name: string;
  language: string;
  description?: string;
}

export type CategoryType =
  | "EDUCATIONAL_RESOURCE"
  | "EXTERNAL_PROVIDERS"
  | "COLORS";

export const CATEGORY_TYPES: CategoryType[] = [
  "EDUCATIONAL_RESOURCE",
  "EXTERNAL_PROVIDERS",
  "COLORS",
];

export type CategoryItemLanguagePayload = {
  language: string;
  name: string;
  description?: string;
};

export type CategoryItemPayload = {
  _id?: string;
  languages: CategoryItemLanguagePayload[];
  icon?: string;
  hexaColor?: string;
  textColor?: string;
  status?: "ACTIVE" | "INACTIVE";
};

export type CategoryPayload = {
  categories: CategoryItemPayload[];
  status?: "ACTIVE" | "INACTIVE";
  type?: CategoryType;
  phoneNumber?: string;
  createdBy?: string;
  updatedBy?: string;
};
